import { gql } from 'apollo-angular';

export const CATEGORY_FRAGMENT = gql`
  fragment CategoryFragment on Category {
    id
    name
    displayName
  }
`;
